import { IntlShape } from 'react-intl';

import { IOffer } from '@rbi-ctg/menu';
import { IDayPartBoundary, IValidDayPart } from 'state/day-part/hooks/use-active-day-parts';
import { isAvailableForActiveDayParts } from 'utils/availability';

interface IIsOfferAvailableArgs {
  offer: IOffer;
  activeDayParts?: IDayPartBoundary[];
}
export const isOfferAvailableForDayParts = ({
  offer,
  activeDayParts,
}: IIsOfferAvailableArgs): boolean => {
  return activeDayParts && activeDayParts.length
    ? isAvailableForActiveDayParts({ activeDayParts, menuData: offer })
    : true;
};

interface IMakeOfferUnavailableMessageArgs {
  offer: IOffer;
  dayParts: ReadonlyArray<IValidDayPart>;
  formatMessage: IntlShape['formatMessage'];
}
export const makeOfferUnavailableMessage = ({
  dayParts,
  offer,
  formatMessage,
}: IMakeOfferUnavailableMessageArgs) => {
  const offerDayPart = dayParts.find(
    dayPart => dayPart.key && offer?.daypart?.includes(dayPart.key)
  );

  return offerDayPart
    ? formatMessage(
        { id: 'nonAvailableOfferUntil' },
        {
          time: offerDayPart.startTime,
        }
      )
    : formatMessage({ id: 'offerNotAvailable' });
};
